// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプトのバージョン本文取得
const AdminOpsPromptGetApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_get";

    const ExecAdminOpsPromptGetApi = async (groupKey, v) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { group_key: groupKey, v: v } });
    };

    return ExecAdminOpsPromptGetApi;
};

export default AdminOpsPromptGetApi;
